module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f31f.030fc669.svg";